export const CREATE_TEAM_COST = 500_000;
export const MAX_TOP_TEAMS = 100;
export const MAX_TEAM_MEMBERS_DISPLAY = 100;
